import { render, staticRenderFns } from "./PaymentSlipsViewComponent.vue?vue&type=template&id=b4442740&"
import script from "./PaymentSlipsViewComponent.vue?vue&type=script&lang=js&"
export * from "./PaymentSlipsViewComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports